import { type ClassValue, clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * Teach tailwind-merge about our custom Tailwind v4 `@theme` tokens. Without this
 * it cannot tell a custom `text-*` font-size from a custom `text-*` color and
 * drops one of them when both appear (e.g. `text-nav-item` lost next to
 * `text-content`). twMerge cannot read the CSS `@theme`, so each custom token
 * must be registered here.
 *
 * When you add a design token, register its bare name in the matching scale:
 *   --text-<x>  -> theme.text   (font-size utilities: `text-<x>`)
 *   --color-<x> -> theme.color  (color utilities: `text-/bg-/border-<x>`)
 *   --font-<x>  -> theme.font   (font-family utilities: `font-<x>`)
 *   --shadow-<x> -> theme.shadow (box-shadow utilities: `shadow-<x>`)
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: [
        "nav-item",
        "section-label",
        "button",
        "page-title",
        "page-subtitle",
        "view-title",
        "view-count",
        "control",
        "row-title",
        "row-subtitle",
        "cell"
      ],
      color: ["content", "content-strong", "content-muted", "separator"],
      font: ["inter", "mona", "quicksand"],
      shadow: ["button"]
    }
  }
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
